document.addEventListener('DOMContentLoaded', () => {
  const search = document.querySelector('[data-search]');
  const clearSearch = document.querySelector('[data-search-clear]');
  const cards = [...document.querySelectorAll('[data-book]')];
  const chips = [...document.querySelectorAll('[data-chip]')];
  const goals = [...document.querySelectorAll('[data-goal]')];
  const status = document.querySelector('[data-catalog-status]');
  const noResults = document.querySelector('[data-no-results]');
  const catalog = document.querySelector('#ebooks');
  let activeFilter = 'recommended';

  const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();

  const renderBooks = () => {
    const query = normalize(search?.value || '');
    let visibleCount = 0;

    cards.forEach(card => {
      const searchText = normalize(card.dataset.search || '');
      const tags = (card.dataset.tags || '').split(/\s+/);
      const rank = Number(card.dataset.rank || 99);
      const matchesSearch = query === '' || searchText.includes(query);
      const matchesFilter = activeFilter === 'recommended' ? rank <= 8 : tags.includes(activeFilter);
      const visible = matchesSearch && (query !== '' || matchesFilter);
      card.hidden = !visible;
      if (visible) visibleCount += 1;
    });

    if (noResults) noResults.hidden = visibleCount !== 0;
    if (status) {
      status.textContent = query
        ? `${visibleCount} resultado${visibleCount === 1 ? '' : 's'} para “${search.value.trim()}”`
        : activeFilter === 'recommended'
          ? 'Una selección corta para elegir sin perderte'
          : `${visibleCount} ebook${visibleCount === 1 ? '' : 's'} en esta selección`;
    }
  };

  const selectFilter = filter => {
    activeFilter = filter;
    chips.forEach(chip => {
      const selected = chip.dataset.chip === filter;
      chip.classList.toggle('active', selected);
      chip.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
    renderBooks();
  };

  search?.addEventListener('input', () => {
    if (search.value.trim() !== '' && activeFilter !== 'recommended') {
      activeFilter = 'recommended';
      chips.forEach(chip => {
        const selected = chip.dataset.chip === 'recommended';
        chip.classList.toggle('active', selected);
        chip.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
    }
    renderBooks();
  });
  clearSearch?.addEventListener('click', () => {
    if (!search) return;
    search.value = '';
    search.focus();
    renderBooks();
  });
  chips.forEach(chip => chip.addEventListener('click', () => selectFilter(chip.dataset.chip)));
  goals.forEach(goal => goal.addEventListener('click', () => {
    selectFilter(goal.dataset.goal);
    catalog?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }));
  renderBooks();

  const drawer = document.querySelector('[data-cart-drawer]');
  const items = document.querySelector('[data-cart-items]');
  const total = document.querySelector('[data-cart-total]');
  const count = document.querySelector('[data-cart-count]');
  const open = () => drawer?.classList.add('is-open');
  const close = () => drawer?.classList.remove('is-open');
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'es-ES', { style: 'currency', currency: 'EUR' }).format(cents / 100);

  async function renderCart() {
    const cart = await fetch('/cart.js').then(response => response.json());
    count?.replaceChildren(document.createTextNode(`Carrito (${cart.item_count})`));
    if (total) total.textContent = money(cart.total_price);
    if (items) {
      items.innerHTML = cart.items.length
        ? cart.items.map(item => `<div class="drawer-item"><img src="${item.image}" alt=""><div><b>${item.product_title}</b><small>${item.quantity} × ${money(item.final_price)}</small></div></div>`).join('')
        : '<p class="drawer-empty">Tu biblioteca aún está vacía.</p>';
    }
  }

  document.querySelectorAll('[data-cart-open]').forEach(element => element.addEventListener('click', async event => {
    event.preventDefault();
    await renderCart();
    open();
  }));
  document.querySelectorAll('[data-cart-close]').forEach(element => element.addEventListener('click', close));
  document.querySelectorAll('form[action="/cart/add"]').forEach(form => form.addEventListener('submit', async event => {
    event.preventDefault();
    const button = form.querySelector('button');
    button.disabled = true;
    button.textContent = 'Añadiendo…';
    try {
      await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      await renderCart();
      open();
    } finally {
      button.disabled = false;
      button.textContent = button.dataset.label || 'Comprar';
    }
  }));
});
